// Ensure the script runs after the DOM content is loaded
document.addEventListener('DOMContentLoaded', function() {
    const lightbox = document.getElementById('ts-lightbox');
    const lightboxImg = document.getElementById('ts-lightbox-img');
    const closeBtn = document.querySelector('.ts-lightbox-close');
    const infographicLinks = document.querySelectorAll('.ts-infographic-link');
    
    // Open lightbox when an infographic is clicked
    infographicLinks.forEach(link => {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        lightboxImg.src = this.href;
        lightbox.style.display = 'flex';
      });
    });
    
    // Close lightbox when the X is clicked
    closeBtn.addEventListener('click', function() {
      lightbox.style.display = 'none';
    });
    
    // Close lightbox when clicking outside the image
    lightbox.addEventListener('click', function(e) {
      if (e.target === lightbox) {
        lightbox.style.display = 'none';
      }
    });
});